import { render, staticRenderFns } from "./PerfumeNotesList.vue?vue&type=template&id=439808ea&scoped=true"
import script from "./PerfumeNotesList.vue?vue&type=script&lang=js"
export * from "./PerfumeNotesList.vue?vue&type=script&lang=js"
import style0 from "./PerfumeNotesList.vue?vue&type=style&index=0&id=439808ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439808ea",
  null
  
)

export default component.exports